import React, { useEffect, useState } from "react";
import { companyType } from "../../../types/comapnyTypes";
import ViewTable from "../../../components/tables/viewTable";
import dayjs from "dayjs";
type PropsType = {
  tableData: companyType[];
};
const SubscriptionTable = (props: PropsType) => {
  const { tableData } = props;
  const [modifiedTableData, setmodifiedTableData] = useState<companyType[]>([]);

  const columns = [
    { header: "Name", accessor: "CompanyName" },
    {
      header: "Expiry Date",
      accessor: "subscriptionValidUpto",
      cell: (row: companyType) =>
        !dayjs(row?.subscriptionValidUpto).isValid()
          ? "NA"
          : dayjs(row?.subscriptionValidUpto).format("MMM DD, YYYY"),
    },
  ];

  useEffect(() => {
    if (tableData) {
      const sortedData = [...tableData].sort((a, b) =>
        dayjs(b.subscriptionValidUpto).diff(dayjs(a.subscriptionValidUpto))
      );
      setmodifiedTableData(sortedData);
    }
    // setmodifiedTableData(tableData ? [...tableData] : []);
  }, [tableData]);
  return (
    <div>
      <ViewTable columns={columns} data={modifiedTableData} />
    </div>
  );
};

export default SubscriptionTable;
